import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Header from "./Components/Header/Header.js";
import Footer from "./Components/Footer/Footer.js";
import Sidebar from "./Components/Sidebar/Sidebar";
import ScrollTop from "./Components/ScrollTop/ScrollTop";

// PAGES
import Home from "./Pages/Home/Home";
import Sobre from "./Pages/Sobre/Sobre";
import Ferramentas from "./Pages/Ferramentas/Ferramentas";

// TOOLS
import CalculoIMC from "./Pages/tools/CalculoIMC/CalculoIMC.js";
import Nasa from "./Pages/tools/NasaDate/Nasa.js";
import NasaSearch from "./Pages/tools/NasaSearch/NasaSearch.js";
import Compressify from "./Pages/tools/Compressify/Compressify.js";
import DeckForge from "./Pages/tools/DeckForge/DeckForge.js";
import ImageToPixelArt from "./Pages/tools/ImageToPixelArt/ImageToPixelArt";
import ArrowForge from "./Pages/tools/ArrowForge/ArrowForge";
import QrCodeGenerator from "./Pages/tools/QrCodeGenerator/QrCodeGenerator";
import WaterIntake from "./Pages/tools/WaterIntake/WaterIntake";
import InstagramResize from "./Pages/tools/InstagramResize/InstagramResize";
import MemoryLab from "./Pages/tools/MemoryLab/MemoryLab.js";

// PÁGINAS IMPORTANTES (ADS)
import Contact from "./Pages/Contact/index.js";
import Privacy from "./Pages/Privacy/index.js";
import Terms from "./Pages/Terms/index.js";

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollTop />
        <Header />

        <div className="App">
          <Sidebar />

          <main className="AppBody">
            <Routes>

              {/* PRINCIPAIS */}
              <Route path="/" element={<Home />} />
              <Route path="/sobre" element={<Sobre />} />
              <Route path="/ferramentas" element={<Ferramentas />} />

              {/* TOOLS (PADRÃO CERTO) */}
              <Route path="/tools/imc" element={<CalculoIMC />} />
              <Route path="/tools/nasa-date" element={<Nasa />} />
              <Route path="/tools/nasa-search" element={<NasaSearch />} />
              <Route path="/tools/compressify" element={<Compressify />} />
              <Route path="/tools/deckforge" element={<DeckForge />} />
              <Route path="/tools/image-to-pixel-art" element={<ImageToPixelArt />} />
              <Route path="/tools/arrow-forge" element={<ArrowForge />} />
              <Route path="/tools/qr-code" element={<QrCodeGenerator />} />
              <Route path="/tools/water-intake" element={<WaterIntake />} />
              <Route path="/tools/instagram-resize" element={<InstagramResize />} />
              <Route path="/tools/memory-lab" element={<MemoryLab />} />

              {/* ADS ESSENCIAL */}
              <Route path="/contato" element={<Contact />} />
              <Route path="/politica-de-privacidade" element={<Privacy />} />
              <Route path="/termos-de-uso" element={<Terms />} />

            </Routes>
          </main>
        </div>

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;